import { Star, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const GOOGLE_MAPS_LISTING = "https://maps.app.goo.gl/W9QvQednDVoZkUSh9";

const TESTIMONIALS = [
  {
    quote:
      "I have been coming to Her Styles for over ten years, and now my daughters come too. The warmth and care have never changed.",
    attribution: "A client for 10+ years",
  },
  {
    quote:
      "My pedicure and manicure are always perfect, and the hair treatments are such good value. I never go anywhere else in Al Qusais.",
    attribution: "Regular client, Al Qusais",
  },
  {
    quote:
      "They did my bridal makeup and henna, and I felt like the most beautiful version of myself on my big day.",
    attribution: "Bridal client",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < 4 ? "fill-[#C9A24B] text-[#C9A24B]" : "text-[#C9A24B]/40"}`}
      />
    ))}
  </div>
);

const GoogleMark = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"
    />
    <path
      fill="#FBBC05"
      d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"
    />
    <path
      fill="#EA4335"
      d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
    />
  </svg>
);

export const Testimonials = () => (
  <section
    id="reviews"
    data-testid="testimonials-section"
    className="scroll-mt-20 bg-[#E3DECF] py-24 sm:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        eyebrow="Client Love"
        title="Kind Words From Our Clients"
      />

      <Reveal className="mt-10">
        <a
          href={GOOGLE_MAPS_LISTING}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-rating-badge"
          className="group mx-auto flex w-fit flex-wrap items-center justify-center gap-x-4 gap-y-2 rounded-full border border-[rgba(69,69,56,0.15)] bg-[#F5F2EB] px-7 py-3.5 shadow-sm transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:border-[rgba(201,162,75,0.6)] hover:shadow-lg"
        >
          <GoogleMark />
          <span className="font-brand text-2xl leading-none text-[#383D33]">4.1</span>
          <Stars />
          <span className="font-body text-xs font-medium uppercase tracking-[0.18em] text-[#383D33]/70">
            68 Google Reviews
          </span>
          <ArrowUpRight className="h-4 w-4 text-[#9A7B2D] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map(({ quote, attribution }, index) => (
          <Reveal key={attribution} delay={index * 120}>
            <figure
              data-testid={`testimonial-card-${index}`}
              className="relative flex h-full flex-col rounded-3xl border border-[rgba(69,69,56,0.12)] bg-[#F5F2EB] p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[rgba(201,162,75,0.55)] hover:shadow-xl"
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute right-7 top-5 font-brand text-7xl leading-none text-[#C9A24B]/25"
              >
                &rdquo;
              </span>
              <Stars />
              <blockquote className="mt-5 flex-1 font-brand text-lg italic leading-relaxed text-[#383D33]">
                {quote}
              </blockquote>
              <div className="gold-hairline mt-6 h-px w-16 opacity-70" />
              <figcaption className="mt-4 font-body text-[11px] font-medium uppercase tracking-[0.25em] text-[#9A7B2D]">
                {attribution}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10 text-center">
        <a
          href={GOOGLE_MAPS_LISTING}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-link"
          className="inline-flex items-center gap-2 font-body text-xs font-semibold uppercase tracking-[0.2em] text-[#9A7B2D] underline-offset-4 transition-colors duration-300 hover:text-[#C9A24B] hover:underline"
        >
          Read all reviews on Google
          <ArrowUpRight className="h-4 w-4" />
        </a>
      </Reveal>
    </div>
  </section>
);
